import React from "react";
import { Logo } from "../components/Logo";
import { ArrowRight, Globe2, Sparkles } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative overflow-hidden grain hero-mesh text-[#F5F5F5] pt-[110px] md:pt-[120px] pb-20 md:pb-32"
    >
      {/* Subtle Peul-pattern overlay */}
      <div className="absolute inset-0 peul-pattern opacity-50 pointer-events-none" />
      <div className="absolute inset-0 dot-grid opacity-[0.08] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-5 md:px-8 lg:px-12">
        {/* Top tag row */}
        <div className="flex items-center gap-3 mb-8 md:mb-10 reveal in">
          <span className="inline-flex h-2 w-2 rounded-full bg-[#D4AF37] dot-pulse shrink-0" />
          <span className="overline text-[#F5F5F5]/70 text-[10px] sm:text-[11px]">
            Depuis 2019 · Abidjan · Dakar · Paris
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8 reveal in">
            <h1 className="font-display font-black tracking-tight text-[36px] leading-[1] xs:text-[42px] sm:text-[58px] md:text-[72px] lg:text-[88px] xl:text-[104px]">
              <span className="text-[#D4AF37]">Think African.</span>
              <br />
              Build Global.
            </h1>
            <p className="mt-6 md:mt-8 text-[#F5F5F5]/70 text-base sm:text-lg md:text-xl max-w-2xl leading-relaxed">
              Hakkilo — <em className="not-italic text-[#D4AF37]">l'intelligence</em>{" "}
              en peul. Nous concevons des solutions technologiques innovantes
              et sécurisées pour accompagner la transformation digitale des
              entreprises et institutions africaines.
            </p>

            <div className="mt-8 md:mt-10 flex flex-col sm:flex-row gap-3">
              <a
                href="#contact"
                data-testid="hero-cta-primary"
                className="beam-btn inline-flex items-center justify-center gap-2 bg-[#D4AF37] hover:bg-[#B8941F] text-[#0A1326] px-6 sm:px-8 py-4 font-bold uppercase tracking-[0.16em] text-xs sm:text-sm rounded-[2px]"
              >
                Parler à un expert
                <ArrowRight size={18} />
              </a>
              <a
                href="#services"
                data-testid="hero-cta-secondary"
                className="inline-flex items-center justify-center gap-2 border border-[#F5F5F5]/30 hover:border-[#D4AF37] hover:text-[#D4AF37] px-6 sm:px-8 py-4 font-bold uppercase tracking-[0.16em] text-xs sm:text-sm rounded-[2px] backdrop-blur-sm transition-colors"
              >
                Découvrir nos expertises
              </a>
            </div>

            {/* Trust row */}
            <div className="mt-10 md:mt-14 flex flex-wrap items-center gap-x-6 sm:gap-x-8 gap-y-3 sm:gap-y-4 text-[12px] sm:text-sm text-[#F5F5F5]/60">
              <div className="flex items-center gap-2">
                <Sparkles size={16} className="text-[#D4AF37]" />
                Intégrité · Excellence · Innovation
              </div>
              <div className="flex items-center gap-2">
                <Globe2 size={16} className="text-[#D4AF37]" />
                Africa Rooted. Global Minded.
              </div>
              <div>+ 50 projets livrés en Afrique de l'Ouest</div>
            </div>
          </div>

          {/* Logo signature card on the right */}
          <div className="lg:col-span-4 reveal in">
            <div className="relative border border-[#D4AF37]/25 bg-white/[0.03] backdrop-blur-md p-8 md:p-10 rounded-[2px] flex flex-col items-center text-center">
              <Logo size={88} variant="light" />
              <div className="mt-6 font-display text-2xl font-extrabold tracking-[0.08em] text-[#F5F5F5]">
                HAKKILO
              </div>
              <div className="font-display text-[10px] tracking-[0.4em] font-semibold text-[#D4AF37] mt-2">
                — TECHNOLOGIES —
              </div>
              <div className="mt-6 pt-6 border-t border-[#D4AF37]/15 w-full">
                <div className="overline text-[#F5F5F5]/50">Notre vision</div>
                <p className="mt-3 text-sm text-[#F5F5F5]/75 leading-relaxed">
                  Devenir le partenaire technologique de référence, enraciné
                  en Afrique, reconnu dans le monde.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
